/** Copy and layout tokens for ContentListPage list pattern (SSOT). */
export const CONTENT_LIST_PAGE_COPY = {
  loading: 'Loading...',
  defaultError: 'Could not load content. Please try again later.',
} as const;
